import { useTranslation } from "react-i18next";
import "../../styles/ComplianceFooter.scss";

export const ComplianceFooter = () => {
  const { t } = useTranslation("dashboard");
  return (
    <section className="compliance-footer" aria-label={t("compliance.ariaLabel")}>
      <img
        src="/assets/compliance/blocco-fse-plus.png"
        alt={t("compliance.blockAlt")}
        className="compliance-footer__block"
      />
      <p className="compliance-footer__phrase">{t("compliance.phrase")}</p>
    </section>
  );
};
